module.exports = __webpack_public_path__ + "static/media/Window-2.c35c33cd.svg";